module.exports = __webpack_public_path__ + "static/media/WINDSOR-PARK-BYLAWS.45ba7c3b.pdf";